import React, { useRef } from "react";

/** Course-wide lesson plan: a one-line summary with an Upload button (coordinators) and the documents when there are any. */
export default function LessonPlanStrip({ docs, loading, uploading, canUpload, onUpload, onOpen }) {
  const fileInput = useRef(null);
  const summary = loading ? "Loading lesson plan…"
    : docs.length === 0 ? "No course-wide lesson plan document yet."
      : `${docs.length} document${docs.length === 1 ? "" : "s"} visible to everyone in the course.`;
  return (
    <div className="plan">
      <div className="plan-h">
        <div><b>Course lesson plan</b><span>{summary}</span></div>
        {canUpload && (
          <>
            <button type="button" className="btn btn-o" disabled={uploading} onClick={() => fileInput.current?.click()}>
              {uploading ? "Uploading…" : "Upload"}
            </button>
            <input ref={fileInput} type="file" hidden aria-label="Upload lesson plan document" onChange={onUpload} />
          </>
        )}
      </div>
      {docs.length > 0 && (
        <ul className="plan-docs">
          {docs.map((item) => (
            <li key={item.id}>
              <button type="button" className="ac-doc" onClick={() => onOpen(item)}>
                <span>{item.title || item.fileName || "Document"}</span><em>Open</em>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
